// extracted by mini-css-extract-plugin
export default {"page":"categories_page__T62TE","header":"categories_header__INT-m","eyebrow":"categories_eyebrow__QW57n","shop":"categories_shop__nCFdP"};